<template>
  <div class="mb-3 row">
    <div class="col">
      <div class="bg-100 shadow-none border card">
        <div class="flex-between-center row gx-0">
          <div class="d-flex align-items-center col-sm-auto">
            <div>
              <h5 class="mb-0 p-3 text-primary fw-bold">
                모니터링<span class="text-info fw-medium">디바이스 선택</span>
              </h5>
            </div>
          </div>
          <div class="p-3 col-md-auto">
            <div class="form-group d-flex align-items-end gap-2">
              <DeviceSelect
                v-if="user" 
                v-model:client="reqSelClient"
                v-model:device="selectDevice"
                :user="user"
                :settype="settype"
                @search="handleSerach"
              />
            </div>
          </div>
        </div>
      </div>

      <MonitorClient
        v-if="selectDevice"
        ref="monitorClientRef"
        :setclient="reqSelClient"
        :setdevice="selectDevice"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

import { onMounted, onUnmounted, ref } from 'vue'
import DeviceSelect from '../components/DeviceSelect.vue'
import MonitorClient from '../components/MonitorClient.vue'
import axios from 'axios'
import type { Device, Client } from '@/types/commontypes'


const user = ref(null)
const settype = ref<string | ''>('')
const reqSelClient = ref<Client>({
    clientcode:'',
    clientname:'',
    clientlevel:0,
    servicestate: 0,
    regdt:''
})

const selectDevice = ref<Device | null>(null)
const monitorClientRef = ref();
let reloadInterval: number | null = null;

onMounted(async () =>{
    settype.value = 'monitor';
    const res = await axios.get('/api/userinfo', { withCredentials: true });
    user.value = res.data.user;
    console.log('로그인된 사용자:', user.value);

    // 1분(60초)마다 reloadData 실행
    reloadInterval = window.setInterval(() => {
        if (monitorClientRef.value && selectDevice.value) {
            monitorClientRef.value.reloadData();
        }
    }, 60000);
});

onUnmounted(() => {
    // 컴포넌트 제거 시 interval 정리
    if (reloadInterval !== null) {
        clearInterval(reloadInterval);
    }
});


// DeviceSelect 컴포넌트에서 search 이벤트
function handleSerach() {
    monitorClientRef.value.reloadData();
}

</script>

<style scoped>
/* 필요 시 스타일 추가 */
</style>